import { db } from "../../firebase";
import {
	collection,
	doc,
	query,
	addDoc,
	setDoc,
	updateDoc,
	getDoc,
	getDocs,
	orderBy,
	where,
	Timestamp,
	deleteDoc as deleteFirestoreDoc
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

interface DataType {
	id?: string;
	collection?: string;
	// created?: Timestamp | string | null;
	css_class?: string;
	show_confetti?: Boolean;
	header_text?: string;
	button_text?: string;
	wave_color?: string;
	user_id?: string;
}

export const ViewRecords = async (currentUser: any): Promise<DataType[]> => {
	try {
		const q = query(collection(db, "configurations"), where("user_id", "==", currentUser.uid), orderBy("created", "desc"));
		const querySnapshot = await getDocs(q);
		const data: DataType[] = [];
		querySnapshot.forEach((doc) => {
			const docData = doc.data();
			const createdDate = getFormattedDate(docData.created);
			data.push({
				id: doc.id,
				collection: docData.collection || "",
				created: createdDate || "",
				css_class: docData.css_class || "",
				show_confetti: docData.show_confetti || false,
				wave_color: docData.wave_color || "",
				user_id: docData.user_id || ""
			});
		});
		return data;
	} catch (error) {
		console.error("Error fetching configurations:", error);
		return [];
	}
};

export const viewRecord = async (recordId: string): Promise<DataType | null> => {
	try {
		const docRef = doc(db, "configurations", recordId);
		const docSnap = await getDoc(docRef);

		if (docSnap.exists()) {
			const data = docSnap.data() as DataType;
			// const createdDate = data.created ? getFormattedDate(data.created) : null;
			return {
				id: docSnap.id,
				collection: data.collection,
				// created: createdDate,
				css_class: data.css_class,
				header_text: data.header_text,
				button_text: data.button_text,
				show_confetti: data.show_confetti,
				user_id: data.user_id
			};
		} else {
			throw new Error("Unable to get configuration data");
		}
	} catch (error) {
		console.error("Error getting configuration: ", error);
		return null;
	}
};

export const addRecord = async (currentUser, newRecord: DataType) => {
	try {
		newRecord.user_id = currentUser.uid;
		const docRef = doc(db, "configurations", uuidv4());
		await setDoc(docRef, newRecord);
	} catch (error) {
		console.error("Error adding user: ", error);
	}
};

export const deleteRecord = async (documentId: string) => {
	try {
		const docRef = doc(db, "configurations", documentId);
		await deleteFirestoreDoc(docRef);
	} catch (error) {
		console.error("Error removing conifiguration: ", error);
	}
};

export const getFormattedDate = (date: Timestamp | string | undefined): string => {
	if (!date) return "";
	const dateObj = typeof date === "string" ? new Date(date) : date.toDate();
	return dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }) + " " + dateObj.toLocaleDateString("en-US");
};
